import { MS_PER_DAY } from "./constants";

/**
 * Converte Date UTC para data juliana.
 * JD = Unix_ms / 86400000 + 2440587.5
 */
export function dateToJulianDate(date: Date): number {
  return date.getTime() / MS_PER_DAY + 2440587.5;
}

export function julianDateToDate(jd: number): Date {
  return new Date((jd - 2440587.5) * MS_PER_DAY);
}
